(function ($) {

    let $headerEl;


    const desktopMediaQueryList = window.matchMedia("(min-width: 1024px)");
    let isDesktopBreakpoint = desktopMediaQueryList.matches;

    desktopMediaQueryList.addEventListener?.("change", checkIfDesktopBreakpoint) || desktopMediaQueryList.addListener(checkIfDesktopBreakpoint);


    function checkIfDesktopBreakpoint() {
        isDesktopBreakpoint = desktopMediaQueryList.matches;
    }



    function checkIfPageScrolled() {
        if (!isDesktopBreakpoint) return;

        if ((window.scrollY || document.documentElement.scrollTop || 0) > 10) {
            $headerEl.addClass('header--scrolled');
        }
        else {
            $headerEl.removeClass('header--scrolled');
        }
    }


    $(document).on('ready', function () {
        $headerEl = $('.header');

        // putting in setTimeout() to give browser more time to load page so value for
        // --header-height is calculated more accurately
        setTimeout(function () {
            const headerHeight = parseInt( $headerEl.outerHeight() );
            const adminBarHeight = parseInt( $('#wpadminbar').outerHeight() );

            if (headerHeight && !isNaN(headerHeight)) {
                $('body').prepend(`<style>
                                :root {
                                    --header-height: ${headerHeight && !isNaN(headerHeight) ? headerHeight : 0}px;
                                    --admin-bar-height: ${adminBarHeight && !isNaN(adminBarHeight) ? adminBarHeight : 0}px
                                }
                            </style>`)
            }
        }, 500);



        checkIfPageScrolled();

        window.addEventListener("scroll", checkIfPageScrolled, {passive: true});

        window.addEventListener("resize", checkIfPageScrolled, {passive: true});

    });


})(jQuery);